<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/PurchaseOfferStatus/elements/Title.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
